import {cloneElement} from 'react'
import {FloatingTree as _FloatingTree, useFloatingParentNodeId} from '@floating-ui/react'

export const FloatingTree = ({children}) => {
	const isNested = !!useFloatingParentNodeId()

	if (isNested) return cloneElement(children, {isNested})

	return <_FloatingTree>{children}</_FloatingTree>
}
